import React from 'react'
import Radium from 'radium'
import {blueBox, greenBox, orangeBox, redBox, yellowBox} from "./BoxStyles";

export const flexStyle = {
  base: {
    display: 'flex'
  },
  fullScreen: {
    width: "100vw",
    height: "calc(100vh - 60px)"
  },
  flexDirectionColumn: {
    flexDirection: 'column'
  },
  flexWrap: {
    flexWrap: 'wrap'
  },
  centered: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  vCentered: {
    // justifyContent: 'center',
    alignItems: 'center'
  },
  left: {
    justifyContent: 'flex-start',
  },
  right: {
    justifyContent: 'flex-end',
  },
  spaceBetween: {
    justifyContent: "space-between"
  },
  flexItem: {
    flex: 1
  },
  flexGrow: {
    flexGrow: 1
  },
  marginBottom: {
    marginBottom: 10,
  },
  margin: {
    marginTop: 10,
    marginRight: 10,
    marginBottom: 10,
    marginLeft: 10,
  },
  vMargin: {
    marginTop: 10,
    marginBottom: 10,
  },
  padding: {
    paddingTop: 10,
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 10,
  },
  round: {
    borderTopLeftRadius: 50,
    borderTopRightRadius: 50,
    borderBottomRightRadius: 50,
    borderBottomLeftRadius: 50,
  }
};

const FlexBox = Radium(({style, reference, column, centered, left, right, wrap, item, flexGrow, margin, vMargin,
                          marginBottom, round, spaceBetween, className, children, onClick, vCenter, fullScreen,
                          red, blue, green, orange, yellow}) =>
  <div ref={reference} className={className} style={[
    flexStyle.base,
    fullScreen && flexStyle.fullScreen,
    column && flexStyle.flexDirectionColumn,
    centered && flexStyle.centered,
    vCenter && flexStyle.vCentered,
    left && flexStyle.left,
    right && flexStyle.right,
    wrap && flexStyle.flexWrap,
    item && flexStyle.flexItem,
    flexGrow && flexStyle.flexGrow,
    margin && flexStyle.margin,
    vMargin && flexStyle.vMargin,
    marginBottom && flexStyle.marginBottom,
    round && flexStyle.round,
    spaceBetween && flexStyle.spaceBetween,
    red && redBox,
    blue && blueBox,
    green && greenBox,
    orange && orangeBox,
    yellow && yellowBox,
    style
  ]}
       onClick={onClick}
  >
    {children}
  </div>
);

export default FlexBox;
